var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143",
    transform: "translate(-1948.671 -839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M1967.223,851.073h-3.875a.608.608,0,0,1,0-1.215h3.875a.608.608,0,0,1,0,1.215Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M1959.1,851.688a.6.6,0,0,1-.429-.178l-1.08-1.08a.607.607,0,0,1,.858-.858l.651.65,1.393-1.392a.607.607,0,1,1,.858.858l-1.822,1.822a.607.607,0,0,1-.429.178Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M1967.223,856.741h-3.875a.607.607,0,1,1,0-1.214h3.875a.607.607,0,0,1,0,1.214Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M1959.1,857.357a.6.6,0,0,1-.429-.178l-1.08-1.08a.607.607,0,0,1,.858-.859l.651.651,1.393-1.393a.607.607,0,0,1,.858.859l-1.822,1.822a.607.607,0,0,1-.429.178Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M1965.1,861.705h-4.859c-4.4,0-6.276-1.878-6.276-6.276v-4.858c0-4.4,1.879-6.276,6.276-6.276h4.859c4.4,0,6.276,1.878,6.276,6.276v4.858C1971.377,859.827,1969.5,861.705,1965.1,861.705Zm-4.859-16.2c-3.733,0-5.061,1.328-5.061,5.062v4.858c0,3.734,1.328,5.062,5.061,5.062h4.859c3.733,0,5.061-1.328,5.061-5.062v-4.858c0-3.734-1.328-5.062-5.061-5.062Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_488",
    "data-name": "Rectangle 488",
    width: 28,
    height: 28,
    transform: "translate(1948.671 839)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProject);
export default __webpack_public_path__ + "static/media/icon-project.9df3c7c722a0937704ac4da0d3900a7b.svg";
export { ForwardRef as ReactComponent };